import {createAction} from 'redux-act';

import {PrescriptionType} from '../../reducers/prescription/prescription/prescriptionTypes';

export const setSavedPrescription = createAction<PrescriptionType>('SET_SAVED_PRESCRIPTION');
